import AccountNotFoundError from "components/error/AccountNotFound";
import NoAccessPage from "components/error/NoAccessPage";
import { ErrorType } from "types/Error";
import AccountInactiveError from "components/error/AccountInactiveError";

import {
  shouldShowAccountInactiveError,
  shouldShowAccountNotFoundError,
  shouldShowUnauthorizedError,
} from "./helpers";

const useErrorHandle = (error: ErrorType | undefined) => {
  const showAccountNotFoundError = shouldShowAccountNotFoundError(error);
  const showAccountInactiveError = shouldShowAccountInactiveError(error);
  const showUnauthorizedError = shouldShowUnauthorizedError(error);

  if (showAccountNotFoundError) {
    return <AccountNotFoundError />;
  }

  if (showAccountInactiveError) {
    return <AccountInactiveError />;
  }

  if (showUnauthorizedError) {
    return <NoAccessPage />;
  }

  return undefined;
};

export default useErrorHandle;
